<div>
  <!-- High-Density Responsive Filters Control Board Pane Wrapper -->
  <div
    class="d-flex flex-wrap align-items-end justify-content-between gap-3 mb-4 p-4 rounded-4 border shadow-sm bg-body-tertiary">

    <!-- Left Block Area: Primary Command Add Registry Actions -->
    <div class="d-flex flex-wrap align-items-end gap-3 flex-grow-1">

      @if (!auditAccess) {
      <div>
        <button type="button"
          class="btn btn-primary d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm fw-medium"
          data-bs-toggle="modal" data-bs-target="#addNew">
          <i class="fa-solid fa-plus font-xs"></i>
          <span>Add New</span>
        </button>
      </div>
      }

      <!-- Dynamic Query Filter Search Input Block Box -->
      <div class="filter-input-field flex-grow-1 max-w-300">
        <label class="form-label font-xs fw-bold text-uppercase tracking-wider text-body-secondary mb-1.5">
          Search Lucky Draw Name
        </label>
        <div class="input-group shadow-sm rounded">
          <span class="input-group-text border bg-body text-body-secondary">
            <i class="fa-solid fa-magnifying-glass font-xs"></i>
          </span>
          <input type="text" name="partOfLuckyDrawName" [(ngModel)]="partOfLuckyDrawName" class="form-control"
            placeholder="Enter keyword..." />
        </div>
      </div>

      <!-- Calendar Timeline Start Date Picker Node -->
      <div class="filter-input-field">
        <label class="form-label font-xs fw-bold text-uppercase tracking-wider text-body-secondary mb-1.5">
          Start Date
        </label>
        <input type="date" [(ngModel)]="startDate" class="form-control shadow-sm font-monospace" />
      </div>

      <!-- Calendar Timeline End Date Picker Node -->
      <div class="filter-input-field">
        <label class="form-label font-xs fw-bold text-uppercase tracking-wider text-body-secondary mb-1.5">
          End Date
        </label>
        <input type="date" [(ngModel)]="endDate" class="form-control shadow-sm font-monospace" />
      </div>

      <!-- Filtering Query Command Actions Execution Triggers Group -->
      <div class="d-flex gap-2">
        <button type="button"
          class="btn btn-info px-3 py-2 shadow-sm text-body fw-bold d-inline-flex align-items-center gap-1.5"
          (click)="listAllWithPartOfName(0)">
          <i class="fa-solid fa-filter font-xs"></i> Check
        </button>
        <button type="button"
          class="btn btn-outline-warning px-3 py-2 shadow-sm fw-semibold d-inline-flex align-items-center gap-1.5"
          (click)="ResetPage()">
          <i class="fa-solid fa-rotate-left font-xs"></i> Clear
        </button>
      </div>

    </div>

    <!-- Right Block Area: Secondary Command reporting Matrix Operations Extracts -->
    <div class="d-flex align-items-end justify-content-sm-end flex-grow-1 flex-md-grow-0 mt-2 mt-md-0">
      <button type="button"
        class="btn btn-success d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm fw-bold w-100 w-sm-auto justify-content-center micro-action-btn"
        [disabled]="apiDownloadLoading()" data-bs-toggle="modal" data-bs-target="#downloadCSVModal">
        @if (apiDownloadLoading()) {
        <span class="spinner-border micro-spinner" role="status" aria-hidden="true"></span>
        <span>Streaming Data...</span>
        } @else {
        <i class="fa-solid fa-file-csv fs-5"></i>
        <span>Download CSV</span>
        }
      </button>
    </div>

  </div>

  <!-- Responsive Administrative Data Table Grid Container -->
  <div class="card border shadow-sm rounded-4 overflow-hidden bg-body w-100">

    <!-- Removed table-responsive to completely lock the 100% full-screen layout -->
    <div class="w-100 overflow-hidden m-0">
      <table class="table table-hover align-middle mb-0 table-dense">

        <thead class="table-light text-body-secondary small text-uppercase border-bottom font-monospace tracking-wider">
          <tr>
            <!-- Total percentage allocations sum up to exactly 100% -->
            <th scope="col" class="ps-3" style="width: 4%;">No</th>
            <th scope="col" style="width: 13%;">Name</th>
            <th scope="col" style="width: 12%;">Material Name</th>
            <th scope="col" style="width: 9%;">Prod Order No</th>
            <th scope="col" style="width: 7%;">Batch No</th>
            <th scope="col" style="width: 6%;">Quantity</th>
            <th scope="col" style="width: 8%;">Start Serial</th>
            <th scope="col" style="width: 8%;">Last Serial</th>
            <th scope="col" style="width: 7%;">Total Pts</th>
            <th scope="col" style="width: 10%;">Created TS</th>
            <th scope="col" style="width: 10%;">Updated TS</th>
            <th scope="col" class="text-center" style="width: 10%;">Activate</th>
            <th scope="col" class="pe-3 text-center" style="width: 6%;">Action</th>
          </tr>
        </thead>

        <tbody class="small text-body">
          @for (data of results() | paginate: { itemsPerPage: pageItemsSize(), currentPage: page(), totalItems:
          allTotal() }; track i; let i = $index) {
          <tr class="transition-base">

            <td class="ps-3 text-body-secondary font-monospace fw-medium">{{ data.srNo }}</td>

            <!-- Truncate long text strings cleanly with (...) instead of stretching or overlapping columns -->
            <td class="fw-semibold text-truncate" [title]="data.name">{{ data.name }}</td>
            <td class="text-body-secondary text-truncate" [title]="data.materialName">{{ data.materialName }}</td>
            <td class="font-monospace text-truncate" [title]="data.productionOrderNumber">{{ data.productionOrderNumber
              }}</td>
            <td class="font-monospace text-truncate" [title]="data.batchNumer">{{ data.batchNumer }}</td>

            <td class="font-monospace">{{ data.quantity | number }}</td>
            <td class="font-monospace text-truncate" [title]="data.qrCodeStartSerialNumber">{{
              data.qrCodeStartSerialNumber }}</td>
            <td class="font-monospace text-truncate" [title]="data.qrCodeLastSerialNumber">{{
              data.qrCodeLastSerialNumber }}</td>
            <td class="font-monospace fw-bold text-primary-emphasis">{{ data.totalPoints | number }}</td>

            <!-- Timestamps now have safe, locked, non-overlapping boundaries -->
            <td class="text-body-secondary font-xs font-monospace text-truncate" [title]="data.createdTs | dateFormat">
              {{ data.createdTs | dateFormat }}</td>
            <td class="text-body-secondary font-xs font-monospace text-truncate" [title]="data.updatedTs | dateFormat">
              {{ data.updatedTs | dateFormat }}</td>

            <!-- Contextual Verification Indicators Mapping -->
            <td class="text-center">
              <div class="d-inline-flex align-items-center gap-1">
                @if (!data.activate) {
                <span
                  class="badge bg-danger-subtle text-danger-emphasis border border-danger-subtle px-1.5 py-1 rounded-pill font-xs">
                  Inactive
                </span>
                <button type="button"
                  class="btn btn-sm btn-icon btn-success rounded-circle shadow-sm transition-base d-inline-flex align-items-center justify-content-center"
                  style="width: 24px; height: 24px;" (click)="Activate(data.name)" title="Activate Campaign">
                  <i class="bi bi-gift" style="font-size: 0.7rem;"></i>
                </button>
                } @else {
                <span
                  class="badge bg-success-subtle text-success-emphasis border border-success-subtle px-2 py-1 rounded-pill font-xs">
                  Active
                </span>
                }
              </div>
            </td>

            <!-- Action Column (Clean, Compact Circular Formats) -->
            <td class="pe-3 text-center">
              <div class="d-inline-flex align-items-center justify-content-center gap-1 w-100">
                @if (!data.activate) {
                <button type="button"
                  class="btn btn-sm btn-icon btn-outline-info text-body rounded-circle shadow-sm transition-base d-inline-flex align-items-center justify-content-center"
                  style="width: 24px; height: 24px;" data-bs-toggle="modal" data-bs-target="#updateData"
                  (click)="GetSingleView(data.name)" title="Edit Parameters">
                  <i class="bi bi-pencil text-body" style="font-size: 0.7rem;"></i>
                </button>
                }

                @if (isEnableDisableAccess && data.activate) {
                <div class="d-inline-flex gap-1">
                  @if (!data.qrCodeEnabled) {
                  <button type="button"
                    class="btn btn-sm btn-icon btn-success rounded-circle shadow-sm transition-base d-inline-flex align-items-center justify-content-center"
                    style="width: 24px; height: 24px;" [disabled]="isEnableBtnLoading()[i]"
                    (click)="enabledDisabled('enabled', data.name, i)" title="Enable QR Code">
                    @if (isEnableBtnLoading()[i]) {
                    <span class="spinner-border micro-spinner m-0" role="status" aria-hidden="true"
                      style="width: 0.65rem; height: 0.65rem;"></span>
                    } @else {
                    <i class="bi bi-check-circle" style="font-size: 0.7rem;"></i>
                    }
                  </button>
                  }

                  @if (data.qrCodeEnabled) {
                  <button type="button"
                    class="btn btn-sm btn-icon btn-danger rounded-circle shadow-sm transition-base d-inline-flex align-items-center justify-content-center"
                    style="width: 24px; height: 24px;" [disabled]="isEnableBtnLoading()[i]"
                    (click)="enabledDisabled('disabled', data.name, i)" title="Disable QR Code">
                    @if (isEnableBtnLoading()[i]) {
                    <span class="spinner-border micro-spinner m-0" role="status" aria-hidden="true"
                      style="width: 0.65rem; height: 0.65rem;"></span>
                    } @else {
                    <i class="bi bi-slash-circle" style="font-size: 0.7rem;"></i>
                    }
                  </button>
                  }
                </div>
                }
              </div>
            </td>
          </tr>
          } @empty {
          <tr>
            <td colspan="13" class="text-center py-5 text-body-secondary">
              <div class="d-flex flex-column align-items-center justify-content-center w-100 text-center">
                <i class="fa-regular fa-folder-open display-6 mb-3 opacity-50"></i>
                <span class="tracking-wider">No Lucky draw records found.</span>
              </div>
            </td>
          </tr>
          }
        </tbody>

      </table>
    </div>
    
  </div>


  <!-- Component Navigation Pagination Footer Area -->
  <div class="d-flex justify-content-center mt-3">
    <pagination-controls [maxSize]="10" previousLabel="&laquo;" nextLabel="&raquo;" [responsive]="true"
      class="dashboard-pagination" (pageChange)="handlePageChange($event)">
    </pagination-controls>
  </div>

</div>

<!-- Floating Mini Card Indicator -->
@if (loading()) {
<div
  class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
  style="backdrop-filter: blur(4px);">
  <!-- Mini Spinner -->
  <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <!-- Text Badge Layout (Uses your global micro utilities) -->
  <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">
    Loading...
  </div>
</div>
}

<!-- ========================================== -->
<!-- CREATE NEW LUCKY DRAW MODAL                -->
<!-- ========================================== -->
<div class="modal fade" id="addNew" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 bg-body">

      <!-- Modal Header -->
      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold text-gradient-primary">
          <i class="fa-solid fa-square-plus me-2"></i>Create New Lucky Draw
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body px-4 py-4">
        <form [formGroup]="newDataForm" class="d-flex flex-column gap-3">

          <!-- Name Field -->
          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3">
              <label class="form-label small fw-bold text-body-secondary mb-0">Name</label>
            </div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm" formControlName="name"
                placeholder="Enter unique name" />
              <div class="form-text text-danger-emphasis font-xs mt-1 fw-medium">
                * Must be unique, cannot update after submit
              </div>
            </div>
          </div>

          <!-- Material Name Field -->
          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3">
              <label class="form-label small fw-bold text-body-secondary mb-0">Material name</label>
            </div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm" formControlName="materialName"
                placeholder="Enter material name" />
            </div>
          </div>

          <!-- Production Order Number Field -->
          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3">
              <label class="form-label small fw-bold text-body-secondary mb-0">Production order number</label>
            </div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm" formControlName="productionOrderNumber"
                placeholder="Enter production order number" />
            </div>
          </div>

          <!-- Batch Number Field -->
          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3">
              <label class="form-label small fw-bold text-body-secondary mb-0">Batch number</label>
            </div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm" formControlName="batchNumer"
                placeholder="Enter batch number" />
            </div>
          </div>

          <!-- Quantity Field -->
          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3">
              <label class="form-label small fw-bold text-body-secondary mb-0">Quantity</label>
            </div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm" formControlName="quantity"
                placeholder="Enter quantity" />
            </div>
          </div>

          <!-- QR Code Start Serial Field -->
          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3">
              <label class="form-label small fw-bold text-body-secondary mb-0">QR code start serial</label>
            </div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm font-monospace" formControlName="qrCodeStartSerialNumber"
                placeholder="Enter start serial" />
            </div>
          </div>

          <!-- QR Code Last Serial Field -->
          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3">
              <label class="form-label small fw-bold text-body-secondary mb-0">QR code last serial</label>
            </div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm font-monospace" formControlName="qrCodeLastSerialNumber"
                placeholder="Enter last serial" />
            </div>
          </div>

          <!-- Form Action Dispatch Button Row -->
          <div class="row g-2 mt-2">
            <div class="col-4 col-md-3"></div>
            <div class="col-8 col-md-9">
              <button type="submit"
                class="btn btn-sm btn-primary px-4 py-2 shadow-sm w-100 d-inline-flex align-items-center justify-content-center gap-2 fw-semibold micro-action-btn"
                (click)="addNewLucky()" [disabled]="!newDataForm.valid || apiLoading()">
                @if (apiLoading()) {
                <span class="spinner-border micro-spinner" role="status" aria-hidden="true"></span>
                <span>Processing...</span>
                } @else {
                <span>Submit <i class="fa-solid fa-paper-plane font-xs"></i></span>
                }
              </button>
            </div>
          </div>

        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer border-top px-4 py-2.5">
        <button type="button" class="btn btn-sm btn-warning shadow-sm px-3 py-1.5 fw-medium"
          data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- ========================================== -->
<!-- UPDATE LUCKY DRAW MODAL                    -->
<!-- ========================================== -->
<div class="modal fade" id="updateData" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 bg-body">

      <!-- Modal Header -->
      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold text-gradient-primary">
          <i class="fa-solid fa-pen-to-square me-2"></i>Update Lucky Draw
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body px-4 py-4">
        <form [formGroup]="updateDataForm" (ngSubmit)="UpdateData()" class="d-flex flex-column gap-3">

          <!-- Read-Only Name Reference Label Row -->
          <div class="row align-items-center g-2 border-bottom pb-2 mb-1">
            <div class="col-4 col-md-3 small fw-bold text-body-secondary">Name</div>
            <div class="col-8 col-md-9 fw-bold text-body font-monospace fs-6">{{ selectedName }}</div>
          </div>

          <!-- Material Name Input -->
          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3">
              <label class="form-label small fw-bold text-body-secondary mb-0">Material name</label>
            </div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm" formControlName="materialName" />
            </div>
          </div>

          <!-- Production Order Number Input -->
          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3">
              <label class="form-label small fw-bold text-body-secondary mb-0">Production order number</label>
            </div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm" formControlName="productionOrderNumber" />
            </div>
          </div>

          <!-- Batch Number Input -->
          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3">
              <label class="form-label small fw-bold text-body-secondary mb-0">Batch number</label>
            </div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm" formControlName="batchNumer" />
            </div>
          </div>

          <!-- QR Code Start Serial Input -->
          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3">
              <label class="form-label small fw-bold text-body-secondary mb-0">QR code start serial</label>
            </div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm font-monospace"
                formControlName="qrCodeStartSerialNumber" />
            </div>
          </div>

          <!-- QR Code Last Serial Input -->
          <div class="row align-items-center g-2">
            <div class="col-4 col-md-3">
              <label class="form-label small fw-bold text-body-secondary mb-0">QR code last serial</label>
            </div>
            <div class="col-8 col-md-9">
              <input type="text" class="form-control shadow-sm font-monospace"
                formControlName="qrCodeLastSerialNumber" />
            </div>
          </div>

          <!-- Form Action Dispatch Button Row -->
          <div class="row g-2 mt-2">
            <div class="col-4 col-md-3"></div>
            <div class="col-8 col-md-9">
              <button type="submit" class="btn btn-sm btn-primary px-4 py-2 shadow-sm w-100 fw-semibold"
                [disabled]="!updateDataForm.valid">
                OK <i class="fa-solid fa-circle-check ms-1 font-xs"></i>
              </button>
            </div>
          </div>

        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer border-top px-4 py-2.5">
        <button type="button" class="btn btn-sm btn-warning shadow-sm px-3 py-1.5 fw-medium"
          data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- ========================================== -->
<!-- DOWNLOAD RECONCILIATION CSV MODAL          -->
<!-- ========================================== -->
<div class="modal fade" id="downloadCSVModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 bg-body">

      <!-- Modal Header -->
      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold text-gradient-primary">
          <i class="fa-solid fa-file-csv me-2"></i>Lucky Draw Download CSV File
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body px-4 py-4">
        <div class="mb-0">
          <label class="form-label small fw-bold text-body-secondary mb-2">Export Target Document Filename
            Configuration</label>
          <div class="input-group shadow-sm rounded">
            <span class="input-group-text border">
              <i class="fa-solid fa-file-signature text-muted"></i>
            </span>
            <input type="text" class="form-control" placeholder="Enter file name" [(ngModel)]="downloadFileName" />
            <span class="input-group-text border font-monospace small">.csv</span>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer border-top px-4 py-2.5">
        <button type="button" class="btn btn-sm btn-secondary opacity-75 shadow-sm px-3 py-1.5 fw-medium"
          data-bs-dismiss="modal">Close</button>
        <button type="button"
          class="btn btn-sm btn-primary px-4 py-1.5 shadow-sm fw-bold d-inline-flex align-items-center gap-2 micro-action-btn"
          (click)="downloadFile()" [disabled]="!downloadFileName || apiDownloadLoading()">
          @if (apiDownloadLoading()) {
          <span class="spinner-border micro-spinner" role="status" aria-hidden="true"></span>
          <span>Extracting...</span>
          } @else {
          <span>Submit <i class="fa-solid fa-circle-down font-xs"></i></span>
          }
        </button>
      </div>

    </div>
  </div>
</div>